module.exports = __webpack_public_path__ + "img/04155259000324.6914a63d.png";